import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

// Blocks a route/section unless the user holds `perm` (owner always passes).
export default function PermissionGate({ perm, children }) {
  const { can, loading } = useAuth();
  if (loading) return null;
  if (can(perm)) return children;
  return (
    <div data-testid="permission-denied" className="flex flex-col items-center justify-center text-center py-24 px-6">
      <div className="w-14 h-14 rounded-md bg-[#1A202E] border border-[#1E293B] flex items-center justify-center mb-4">
        <Lock className="w-6 h-6 text-slate-500" />
      </div>
      <h2 className="font-display text-2xl text-white mb-1">Restricted area</h2>
      <p className="text-sm text-slate-400 max-w-sm">
        You don&rsquo;t have permission to view this. Ask the workspace owner to grant access from Admin → Team.
      </p>
    </div>
  );
}
